<template>
    <div class="new-entry--container">
        <h4>Přidat záznam ({{ calendarName }})</h4>
        <div class="new-entry--form">
            <label for="name">Začatek</label>
            <DateTimePicker
                :singleDate="true"
                :alignRight="true"
                timeFormat="HH:mm"
                @onChange="setStartDate"
            />

            <label for="name">Název</label>
            <input type="text" class="form-control" id="name" placeholder="Name" v-model="name">

            <label for="name">Délka (hod)</label>
            <input type="number" class="form-control" id="name" placeholder="2" v-model="length">
            
            <RRuleEditor :startDate="startDate" v-model="rrule"></RRuleEditor>
            <button type="submit" class="btn btn-primary mb-2" @click="addEvent">{{ $t('add') }}</button>
        </div>
    </div>
</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import _ from 'lodash'
import { dateObjectFromInput } from 'CORE/utils/date'
import moment from 'moment'
import RRuleEditor from './rrule-editor'
import { RRule } from 'rrule'
import DateTimePicker from 'CORE/components/utilities/date-time-picker/components/DateTimePicker'

export default {
    name: 'EventEditor',
    components: {
        RRuleEditor,
        DateTimePicker,
    },
    props: {
        value: {
            required: false,
            type: Object,
        },
        calendar: {
            required: false,
            type: Object,
        }
    },
    data: function() {
        return {
            startDate: new Date(),
            rrule: {},
            name: "",
            length: 1,
        }
    },
    methods: {
        setStartDate(date) {
            this.startDate = date.startDate
            this.$emit('input', this.normalizedEventData)
        },
        async addEvent() {
            const rrule = new RRule(this.rrule)
            try {
                const response = await this.$store.dispatch('createEvent', {
                    title: this.name,
                    start: moment(this.startDate).format('X'),
                    duration: this.length * 3600,
                    calendar: this.calendar,
                    rrule: rrule.toString(),
                })
                this.$emit('success', response)
                this.flash(`Ulozeno`, 'success')
            } catch(e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
            }
        }
    },
    watch: {
        normalizedEventData() {
            this.$emit('input', this.normalizedEventData)
        },
    },
    computed: {
        normalizedEventData() {
            const rule = new RRule(this.rrule)
            return {
                name: this.name,
                length: _.parseInt(this.length) * 3600,
                startDate: this.startDate,
                rrule: rule.toString()
            }
        },
        calendarName() {
            return _.get(this, 'calendar.name', '')
        }
    },
}
</script>

<style scoped>
.calendar-selector > label {
    margin: 0 0 0 6px;
}
.calendar-selector .fa-plus-circle {
    margin-left: 6px;
    cursor: pointer;
}
.new-entry--form {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 4fr 1fr 1fr;
  grid-template-rows: auto;
  grid-gap: 10px;
}
.new-entry--container {
    padding: 10px;
    margin: 10px 0 10px 0;
    background-color: white;
    border: 1px solid #ced4da;
}
.rrule-editor--container {
    grid-column-start: 1;
    grid-column-end: span 6;
    grid-row-start: 2;
    grid-row-end: span 2;
}
h4 {
    text-align: center;
}
</style>
